import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import classNames from 'classnames'

import './index.styles.css'

interface Props {
  description: string
  squared?: boolean
}

export default function EmptyList({ description, squared = false }: Props) {
  return (
    <Box
      className={classNames(
        squared ? 'EmptyList_emptyList_squared' : 'EmptyList_emptyList_default'
      )}
    >
      {description}
    </Box>
  )
}
